import { render, staticRenderFns } from "./AdminPopupInformation.vue?vue&type=template&id=73552c0a&scoped=true&"
import script from "./AdminPopupInformation.vue?vue&type=script&lang=js&"
export * from "./AdminPopupInformation.vue?vue&type=script&lang=js&"
import style0 from "./AdminPopupInformation.vue?vue&type=style&index=0&id=73552c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73552c0a",
  null
  
)

export default component.exports